export default __webpack_public_path__ + "static/media/tender3.c87eb6dc.png";